import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { DeficiencyType, EventData, EventsListProps } from '@/utils/types';
import {
  eventTypeMap,
  insuranceEventsApiKeys,
  insuranceEventNames,
  eventTypes,
} from '@/utils/constants/insuranceTab';
import attachements from '@/assets/icons/attachments.svg';
import infoIcon from '@/assets/icons/infoIcon.svg';
import moreIcon from '@/assets/icons/more-icon.svg';
import ArrowUp from '@/assets/icons/arrow-up.svg';
// import { PolicyBilling } from '@/api/models/Contracts';
import { fetchPolicyBillingStart } from '@/store/features/policyBilling/policySlice';
import { useAppDispatch, useAppSelector } from '@/hooks/storeHook';

function getEventType(
  placement: string | undefined,
  action: string,
  deficiency: DeficiencyType,
  selectedTab?: string | number,
  forceDeficiencyEvent?: boolean,
): string {
  const eventMap: Record<string, Record<string, string>> = {
    FP: {
      CANCEL: insuranceEventNames.asssurantPolicyCancelEvent,
      NEWPOL: insuranceEventNames.assurantPolicyAddEvent,
      ENDORS: insuranceEventNames.assurantPolicyAddEvent,
    },
    VOL: {
      CANCEL: insuranceEventNames.outsidePolicyCancelEvent,
      NEWPOL: insuranceEventNames.outsidePolicyAddEvent,
      RENEW: insuranceEventNames.outsidePolicyRenewEvent,
      ENDORS: insuranceEventNames.outsidePolicyUpdatedEvent,
      NRENEW: insuranceEventNames.outsidePolicyNotRenewedEvent,
      REINST: insuranceEventNames.outsidePolicyReinstatedEvent,
    }
  };

  if (forceDeficiencyEvent || (placement === 'VOL' && deficiency === 'Y' && Number(selectedTab) === 4)) {
    return insuranceEventNames.deficiencyEvent;
  }

  if (action === '1 Declaration Page/New/Renewals') {
    return insuranceEventNames.letterEvent;
  }
  if (action === '11 Deficiency/On-Demand Letters') {
    return insuranceEventNames.letterEvent;
  }
  if (action === '6 Correspondence/Letters') {
    return insuranceEventNames.letterEvent;
  }
  if (action === '4 Cancel/Non-Renewal/Lapse Notices') {
    return insuranceEventNames.letterEvent;
  }
  if (action === 'OI Outside Insurance') {
    return insuranceEventNames.letterEvent;
  }
  if (action === 'phoneEvent') {
    return insuranceEventNames.phoneEvent;
  }
  if (action === 'emailEvent') {
    return insuranceEventNames.emailEvent;
  }

   if(placement){
    return  eventMap[placement][action];
  }

  return  insuranceEventNames.UnknownEvent;

}

// const openPdfInNewTab = (base64String: string) => {
//   const byteCharacters = atob(base64String);
//   const byteNumbers = new Array(byteCharacters.length)
//     .fill(0)
//     .map((_, i) => byteCharacters.charCodeAt(i));
//   const byteArray = new Uint8Array(byteNumbers);
//   const blob = new Blob([byteArray], { type: 'application/pdf' });
//   const blobUrl = URL.createObjectURL(blob);
//   const newTab = window.open(blobUrl, '_blank');
//   if (newTab) {
//     newTab.focus();
//   } else {
//     alert('Popup blocked. Please allow popups for this site.');
//   }
// }
const formatEventValue = (
  event: Record<string, unknown>,
  key: string,
  selectedTab?: string | number,
): string => {
  const rawValue = event[key] as string;
  const isDeficiencyEvent =
    getEventType(
      event.placement as string,
      event.eventType as string,
      event.deficient as DeficiencyType,
      selectedTab,
      event.forceDeficiencyEvent as boolean | undefined,
    ) === insuranceEventNames.deficiencyEvent;

  const isDeficiencyCodeKey = key === insuranceEventsApiKeys.deficiencyCode;

  if (isDeficiencyEvent && isDeficiencyCodeKey && Array.isArray(rawValue)) {
    return (rawValue as string[]).map((code) => code.slice(0, 2)).join(', ');
  }
  return rawValue;
};

export const EventsList: React.FC<EventsListProps> = ({
  clientId,
  eventsList,
  selectedTab,
  onDeficiencyClick,
  onPolicyBillingClick,
  onOIPolicyClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useAppDispatch();
  // const [isDeficiencyPopupOpen, setDeficiencyPopupOpen] = useState(false);
  // const [currentDeficiencyCodes, setCurrentDeficiencyCodes] = useState<string[]>([]);
  const [clickedPolicyId, setclickedPolicyId] = useState<string>('');

  const { policyBilling, loading, policyId } = useAppSelector((state) => state.policyBilling);

  const visibleEvents = () => {
    if (isExpanded || eventsList.length <= 2) return eventsList;
    return [eventsList[0], eventsList[eventsList.length - 1]];
  };

  useEffect(() => {
    if (selectedTab === 0) {
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  }, [eventsList]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      // const { scrollTop, scrollHeight, clientHeight } = container;
      // const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
      const { scrollTop } = container;
      setShowScrollTop(scrollTop > 10);
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!loading && clickedPolicyId && policyId == clickedPolicyId) {
      setclickedPolicyId('');
      onPolicyBillingClick(clickedPolicyId, policyBilling, false);
    }
  }, [loading, clickedPolicyId, policyBilling, policyId]);



  const handleClickForPolicyAndDeficiency = (
     eachEvent : EventData,
    itemKey: string,
    eventType: string,
    value: unknown,
    label: string,
    deficiencyCode?: string[] | [],
   
  ) => {
    const isPolicyNumber = itemKey === insuranceEventsApiKeys.policyNumber;
    const isDeficientCode = itemKey === insuranceEventsApiKeys.deficiencyCode;

    const isAssurantEvent = [
      insuranceEventNames.asssurantPolicyCancelEvent,
      insuranceEventNames.assurantPolicyAddEvent,
    ].includes(eventType);


    const isOutsideEvent = [
      insuranceEventNames.outsidePolicyCancelEvent,
      insuranceEventNames.outsidePolicyAddEvent,
      insuranceEventNames.outsidePolicyRenewEvent,
      insuranceEventNames.outsidePolicyUpdatedEvent,
      insuranceEventNames.outsidePolicyNotRenewedEvent,
      insuranceEventNames.outsidePolicyReinstatedEvent,
    ].includes(eventType);

    if ((isPolicyNumber && isAssurantEvent) || (isPolicyNumber && isOutsideEvent) || isDeficientCode) {

      const clickHandler = (isPolicyNumber && isAssurantEvent)
        ? () => handleAssurantPolicyEvent(label, value as string) : (isPolicyNumber && isOutsideEvent) ?  () => handleOIPolicyEvent(label,value as string ,eachEvent) 
        : () => onDeficiencyClick(deficiencyCode ?? []);

      return {
        className: 'valueClickable',
        onClick: clickHandler,
      };
    }

    return {
      className: 'value',
      onClick: undefined,
    };
  };
  const scrollToTop = () => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleAssurantPolicyEvent = (label: string, value: string) => {
    setclickedPolicyId(value);
    dispatch(fetchPolicyBillingStart({ policyId: value, clientId:clientId }));
    onPolicyBillingClick(value, [], true);
  };
  const handleOIPolicyEvent = (label: string, value: string, eachEvent: EventData) => {
    setclickedPolicyId(value);

    onOIPolicyClick(eachEvent);
  };

  const openPdfInNewTab = (attachmentUrl: string) => {
    const domain = window.location.origin;
    window.open(`${domain}${attachmentUrl}`, '_blank');
  };
  const formatDate = (DateStr: string) => {
    // if(DateStr==''){
    //   return '00/00/00'
    // }
    const date =new Date(DateStr);
    return (
      `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
      `${date.getDate().toString().padStart(2, '0')}/` +
      date.getFullYear().toString().slice(-2)
    );
  };
  const formatDateYear = (DateStr: string) => {
    // if(DateStr==''){
    //   return '00/00/00'
    // }
    const date = new Date(DateStr);
    return (
      `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
      `${date.getDate().toString().padStart(2, '0')}/` +
      date.getFullYear().toString()
    );
  };
  const formatAmount = (value: string): string => {
    if (value) {
      const clean = value.replace(/,/g, '').trim();

      const number = parseFloat(clean);
      if (isNaN(number)) return value;
      return `$${number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    } else return '';
  };
  return (
    <div className="events-list_scrollable-wrapper" ref={containerRef}>
      <div className="events-list_scrollable" >
        {visibleEvents().length === 0 ? (
          <div className="no-data-message">
            <Typography className="no-data-text">No Events data available</Typography>
          </div>
        ) : (
          visibleEvents().map((eachEvent, index) => {
          if(!eventTypes.includes(eachEvent.eventType)) return null;
            const eventDetails =
               eventTypeMap[
              getEventType(
                eachEvent.placement,
                eachEvent.eventType,
                eachEvent.deficient,
                selectedTab,
                eachEvent.forceDeficiencyEvent,
              )
              ];

            return (
              <div key={index} className="insurance-timeline_wrap">
                <div className="date-info_wrap">
                  <div className="date-info-conatiner">
                    <Typography className="date">{eachEvent.enteredOn && !isNaN(new Date(eachEvent.enteredOn).getTime())
      ? formatDate(eachEvent.enteredOn)
      : <span className="date-placeholder" />}</Typography>
                    <div className="icon_wrap">
                      <Tooltip
                        title={
                          <React.Fragment>
                            <div>
                              <strong>Entered By:</strong> {eachEvent.entered_by}
                            </div>
                            <div>
                              <strong>Entered on Date:</strong> {eachEvent.enteredOn && !isNaN(new Date(eachEvent.enteredOn).getTime())
      ? formatDate(eachEvent.enteredOn)
      : '\u00A0'}
                            </div>
                          </React.Fragment>
                        }
                      >
                        <img src={infoIcon} alt="info-icon" className="info-icon" />
                      </Tooltip>

                      {eachEvent.attachmentAvailable && eachEvent.attachmentUrl && (
                        <img
                          src={attachements}
                          alt="attachment-icon"
                          className="attach-icon"
                          onClick={() => {
                            openPdfInNewTab(eachEvent.attachmentUrl);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="insurance-timeline_container">
                  <div className="insurance-timeline">
                    <div className="list_wrap">
                      <Typography className="heading">{eventDetails.heading}</Typography>
                      <div className="list-container">
                        {eventDetails.fieldsData.map((item, fieldIndex) => {
                          let value = formatEventValue(
                            eachEvent as unknown as Record<string, unknown>,
                            item.key,
                            selectedTab,
                          );

                          const dateLabels = [
                            'Effective',
                            'Effective Date',
                            'Expiration',
                            'Cancel Effective',
                            'Def History',
                            'Letter History',
                          ];

                          if (dateLabels.includes(item.label) && value) {

                            const date = new Date(value);
                            value = isNaN(date.getTime()) ? value : formatDateYear(value);
                          }
                          if (item.label === 'Refund Amount' && value) {
                            value = formatAmount(value);
                          }

                          return (
                            <div key={fieldIndex} className="list-item">
                              <Typography className="label">{item.label}</Typography>
                              <Typography
                                {...handleClickForPolicyAndDeficiency(
                                  eachEvent,
                                  item.key,
                                  getEventType(
                                    eachEvent.placement,
                                    eachEvent.eventType,
                                    eachEvent.deficient,
                                    selectedTab,
                                    eachEvent.forceDeficiencyEvent,
                                  ),
                                  value,
                                  item.label,
                                  eachEvent.deficiencyCode
                                )}
                              >
                                {value}
                              </Typography>
                            </div>
                          );
                        })}
                      </div>
                      {!isExpanded && eventsList.length > 2 && index === 0 && (
                        <div className="view-all-wrapper">
                          <div onClick={() => setIsExpanded(true)} className="view-all-link">
                            <Typography className="more-items">{eventsList.length} Mo.</Typography>
                            <img src={moreIcon} alt="more-icon" className="expand-more-icon" />
                            <Typography className="view"> View all</Typography>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop}>
          <img src={ArrowUp} alt="info-icon" className="scroll-icon" />
        </div>
      )}
    </div>
  );
};

